import React, { useEffect, useState } from "react";
import {
  Drawer,
  Grid,
  IconButton,
  makeStyles,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { Group } from "@material-ui/icons";
import { teamAnalyticsSelector } from "../../redux/selectors";
import { useDispatch, useSelector } from "react-redux";
import { loadTeamAnalytics } from "../../redux/actions";
import { Skeleton } from "@material-ui/lab";
import { CaseAllocationTile } from "./TileRenderers/CaseAllocationTile";
import { useNavigate } from "../../hooks/useNavigation";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "20px",
    width: "500px",
    height: "100%",
    position: "relative",
  },
  heading: {
    color: "#9f9f9f",
    fontSize: "1.2em",
    fontWeight: 600,
  },
}));
export const CaseAllocation: React.FC = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const dispatch = useDispatch();
  const teamAnalyticsState = useSelector(teamAnalyticsSelector);
  const { data, loadingState } = teamAnalyticsState;
  const { location } = useHistory();

  const classes = useStyles();

  const navigate = useNavigate(location);
  const navigateToFilter = (filterUrl: string) => navigate(filterUrl);

  const handleMenuOpen = () => {
    setIsOpen(true);
  };

  const handleMenuClose = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    if (isOpen) dispatch(loadTeamAnalytics());
  }, [dispatch, isOpen]);

  return (
    <>
      <Tooltip title="Case allocation">
        <IconButton
          size="medium"
          onClick={handleMenuOpen}
          data-test="case-allocation"
          aria-controls="case-allocation"
          aria-haspopup="true"
          style={{ color: "#fff" }}
        >
          <Group />
        </IconButton>
      </Tooltip>
      <Drawer anchor="right" open={isOpen} onClose={handleMenuClose}>
        <div className={classes.root}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="h6" className={classes.heading}>
                Case allocation
              </Typography>
            </Grid>
            {loadingState === "LOADED" ? (
              data.map((tile, index) => {
                return (
                  <CaseAllocationTile
                    key={index}
                    tile={tile}
                    navigate={navigateToFilter}
                  />
                );
              })
            ) : (
              <Grid item xs={12}>
                <Skeleton variant="text" height={60} />
                <Skeleton variant="text" height={60} />
                <Skeleton variant="text" height={60} />
                <br />
                <Skeleton variant="rect" height={118} />
              </Grid>
            )}
          </Grid>
        </div>
      </Drawer>
    </>
  );
};
